import { render, staticRenderFns } from "./companyRecharge.vue?vue&type=template&id=85a0d2dc&scoped=true"
import script from "./companyRecharge.vue?vue&type=script&lang=ts"
export * from "./companyRecharge.vue?vue&type=script&lang=ts"
import style0 from "./companyRecharge.vue?vue&type=style&index=0&id=85a0d2dc&prod&scoped=true&lang=css"
import style1 from "@/styles/editor.scss?vue&type=style&index=1&id=85a0d2dc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a0d2dc",
  null
  
)

export default component.exports